import React from 'react';
import './HomeGallery.css';

const images = [
  { name: 'home-selfie', width: 1997, height: 2417,
    alt: '聖書をそばに置き、ソファで自撮りする女の子。asmrchurch.com',
    en: 'A girl taking a selfie on a sofa with a Bible beside her. asmrchurch.com' },
  { name: 'home-welcome', width: 2815, height: 2193,
    alt: '聖書とマグカップのそばでくつろぐ女の子。JESUS LOVES YOU — asmrchurch.com',
    en: 'A girl relaxing beside a Bible and a mug. JESUS LOVES YOU — asmrchurch.com' },
  { name: 'home-reading', width: 2140, height: 1904,
    alt: '聖書のそばに横になり、手紙を手にする女の子。',
    en: 'A girl lying beside a Bible, holding a letter.' },
];

export default function HomeGallery({ english = false }) {
  return (
    <section className="home-gallery" aria-label={english ? 'Illustration gallery' : 'イラストギャラリー'}>
      <div className="home-gallery__track" tabIndex={0}
        aria-label={english ? 'Scroll horizontally to see all three illustrations' : '横にスクロールして3枚のイラストを見る'}>
        {images.map((item) => (
          <picture className="home-gallery__image" key={item.name}>
            <source type="image/webp" srcSet={`/static/images/${item.name}-640.webp 640w, /static/images/${item.name}-1280.webp 1280w`} sizes={`min(${(item.width / item.height * 70).toFixed(2)}vh, ${(item.width / item.height * 100).toFixed(2)}vw)`} />
            <img src={`/static/images/${item.name}.jpg`} alt={english ? item.en : item.alt} width={item.width} height={item.height} decoding="async" draggable={false} />
          </picture>
        ))}
      </div>
    </section>
  );
}
